import { CalendarOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { Box, Flex, colors } from '@weareberyl/design-system'

export const ScheduledIcon = () => (
  <Tooltip title="Scheduled bay suspensions" placement="top">
    <Flex flexWrap="nowrap" alignItems="center" justifyContent="center">
      <Box
        aria-label="Scheduled bay suspensions"
        title="Scheduled bay suspensions"
        borderRadius="100%"
        alignItems="center"
        bg={'berylGreen'}
        mt="3px"
        p="2px"
        height={24}
        width={24}
      >
        <CalendarOutlined
          style={{ fontSize: 14, paddingTop: 3, color: colors.buttonText }}
        />
      </Box>
    </Flex>
  </Tooltip>
)
